import company_info from '../../../.cache/companyinfo/companyInfo.json';
import weekly_plan from '../../../.cache/specialplans/weekly.json';
import placeholder_data from '../../../.cache/placeholderData/placeholderData.json';

// prettier-ignore
export const ERROR_MESSAGES = {
  required: 'error_required',
  email: 'error_email',
  numeric: 'error_numeric',
  phone: 'error_phone',
  zip: 'error_zip',
  chooseValue: 'error_choose_value',
  chooseRadio: 'error_choose_radio',
  chooseCheckbox: 'error_choose_checkbox',
  chooseAdultsOrKids: 'error_choose_adults_or_kids',
  jobRequired: 'error_job_required',
  employerRequired: 'error_employer_required',
  schoolRequired: 'error_school_required',
  requiredEmail: 'error_required_email',
  requiredJob: 'error_required_job',
  emailNotValid: 'error_email_not_valid',
  isEmailDuplicate: 'error_email_duplicate',
  emailNotFound: 'error_email_not_found',
  invalidUrl: 'error_invalid_url',
  isSlugDuplicate: 'duplicate_slug',
  emailPassowrdNotMatch: 'error_password_match',
  userNotHavePassword: 'error_user_not_have_password'
};

export const TEST_DATE = new Date(1995, 11, 17, 12, 0, 0);
export const WEEKLY_POOL = weekly_plan;

export const JOB_TRACKING_HOST = ['cvdeboss', 'modeles-cv'];
export const ACCPTED_CARDS_LOGO = [
  { img: 'cbV7.png', alt: 'CB' },
  { img: 'masterCardV7.png', alt: 'MasterCard' },
  { img: 'visaV7.png', alt: 'Visa' },
  { img: 'americanExpressV7.png', alt: 'American Express' },
];

export const NEW_ACCPTED_CARDS_LOGO = [
  { img: 'masterCardV7.png', alt: 'MasterCard' },
  { img: 'McAfee.png', alt: 'McAfee' },
  { img: 'PciDss.png', alt: 'Pci Dss' },
  { img: 'NewVisa.png', alt: 'Visa' },
];

export const COMPANY_INFO = company_info.companyInfo;

export const PLACEHOLDER_DATA = placeholder_data.placeholderData;

export const STORE_REDIRECT_HOST = 'resume-example';

export const FREE_CHECKOUT_DOMAIN = [
  { domain: 'elegantcv', country: ['BR', 'EG', 'IN', 'LK', 'PK', 'TH'] },
  { domain: 'cvdeboss', country: ['DZ', 'MG'] },
  { domain: 'resumedone', country: ['EG', 'IN', 'PK', 'TR'] },
  { domain: 'resumizeme', country: ['EG', 'IN', 'LK', 'PK', 'TR'] },
  { domain: 'bestonlineresume', country: ['IL', 'IN', 'LK', 'PK', 'TR'] },
  { domain: 'cvtoolspro', country: ['IN', 'PK', 'PS', 'TH'] },
  { domain: 'modeles-cv', country: ['MG', 'SN'] },
  { domain: 'cv-lite', country: ['PK', 'TZ', 'UG'] },
  { domain: 'resume-example', country: ['PK'] },
  { domain: 'theresumeranger', country: ['VN'] },
];

export const CHEKBOX_CANCEL_SUBSCRIPTION_ITEM = (isAutoApplyUser) => {
  if (isAutoApplyUser) {
    return [
      { name: 'reason_1', value: 'contact_cancel_subscription_reason_1' },
      { name: 'reason_2', value: 'contact_cancel_subscription_reason_2' },
      { name: 'reason_3', value: 'contact_cancel_subscription_reason_3' },
      { name: 'reason_4', value: 'contact_cancel_subscription_reason_4' },
      { name: 'reason_5', value: 'contact_cancel_subscription_reason_5' },
    ];
  }
  return [
    { name: 'reason_1', value: 'newText_contact_cancel_subscription_reason_1' },
    { name: 'reason_2', value: 'newText_contact_cancel_subscription_reason_2' },
    { name: 'reason_3', value: 'newText_contact_cancel_subscription_reason_3' },
    { name: 'reason_4', value: 'newText_contact_cancel_subscription_reason_4' },
    { name: 'reason_5', value: 'contact_cancel_subscription_reason_5' },
  ];
};

export const CANCEL_SUBSCRIPTION_TEXT = (isAutoApplyUser) => {
  if (isAutoApplyUser) {
    return {
      mainTitle: 'cancel_subscription_autoApply_title',
      infowrap_title: 'cancel_subscription_autoApply_infotitle',
      infowrap_info: 'cancel_subscription_autoApply_infodesc',
      subtitle: 'cancel_subscription_autoApply_description',
      inputwrap_label: 'cancel_subscription_autoApply_ITitle',
      inputwrap_placeholder: 'cancel_subscription_autoApply_Iplaceholder',
      btn_1: 'cancel_subscription_autoApply_btn1',
      btn_2: 'cancel_subscription_autoApply_btn2',
    };
  }
  return {
    mainTitle: 'cancel_subscription_autoApply_title',
    infowrap_title: 'cancel_subscription_autoApply_infotitle',
    infowrap_info: 'newText_cancel_subscription_autoApply_infodesc',
    subtitle: 'newText_cancel_subscription_autoApply_description',
    inputwrap_label: 'cancel_subscription_autoApply_ITitle',
    inputwrap_placeholder: 'cancel_subscription_autoApply_Iplaceholder',
    btn_1: 'newText_cancel_subscription_autoApply_btn1',
    btn_2: 'cancel_subscription_autoApply_btn2',
  };
};

export const BLUEPILL_HOSTS = ['bluepill', 'bluepillwork'];

export const ONE_YEAR_HIDE_HOST = ['cvelevator', 'theresumeranger', 'modeles-cv'];

export const LANGUAGES_TAGS = [
  { locale: 'en', slug: 'languages_tags_en' },
  { locale: 'fr', slug: 'languages_tags_fr' },
  { locale: 'es', slug: 'languages_tags_es' },
  { locale: 'de', slug: 'languages_tags_de' },
  { locale: 'it', slug: 'languages_tags_it' },
];
